import store from "@/store";

enum TriggerProperty {
  CarbonFootprint = 0,
  EconomicProsperity = 1,
  Employment = 2,
  HealthHappinessAndWellbeing = 3,
  Wildlife = 4
}

class Trigger {
  public property: TriggerProperty;
  public direction = 1;
  public value: number;

  constructor(property: TriggerProperty, value: number, direction: number) {
    this.property = property;
    this.value = value;
    this.direction = direction;
  }
}

class Result {
  public carbonFootprint = 0;
  public economicProsperity = 0;
  public employment = 0;
  public healthHappinessAndWellbeing = 0;
  public wildlife = 0;

  constructor(
    carbonFootprint = 0,
    economicProsperity = 0,
    employment = 0,
    healthHappinessAndWellbeing = 0,
    wildlife = 0
  ) {
    this.carbonFootprint = carbonFootprint;
    this.economicProsperity = economicProsperity;
    this.employment = employment;
    this.healthHappinessAndWellbeing = healthHappinessAndWellbeing;
    this.wildlife = wildlife;
  }
}

class Event {
  public trigger: Trigger;
  public text: string;
  public result: Result;
  public activated = false;

  constructor(text: string, trigger: Trigger, result: Result) {
    this.text = text;
    this.trigger = trigger;
    this.result = result;
  }
}

const events: Event[] = [];

function awake() {
  // Event 1
  const eventOne = new Event(
    "You have seen a reduction of wildlife in your city. The decline in wildlife has affected green space in your city and had a negative affect on food production.",
    new Trigger(TriggerProperty.Wildlife, -5, -1),
    new Result(-3, -1, -1, -2, -3)
  );

  // Event 2
  const eventTwo = new Event(
    "Your city is producing too much carbon. Air pollution is a problem throughout your city, this will affect the health of your citizens. ",
    new Trigger(TriggerProperty.CarbonFootprint, -7, -1),
    new Result(-3, 0, -1, -3, -3)
  );

  // Event 3
  const eventThree = new Event(
    "Your increased carbon production has raised sea levels, your city is struggling with flooding.",
    new Trigger(TriggerProperty.CarbonFootprint, -10, -1),
    new Result(-1, -3, -2, -2, -1)
  );

  // Event 4
  const eventFour = new Event(
    "Your city isn't making enough money. Buildings fall into disrepair and unemployment increases.",
    new Trigger(TriggerProperty.EconomicProsperity, -2, -1),
    new Result(0, -3, -2, -2, -1)
  );

  // Event 5
  const eventFive = new Event(
    "Your citizens are becoming unhealthy. They are missing more days at work and your city is becoming less productive.",
    new Trigger(TriggerProperty.HealthHappinessAndWellbeing, -4, -1),
    new Result(0, -2, -3, -3, 0)
  );

  // Event 6
  const eventSix = new Event(
    "Your city has seen additional investment and economic growth, new businesses and industries are emerging.",
    new Trigger(TriggerProperty.EconomicProsperity, 8, 1),
    new Result(0, 3, 3, 1, 0)
  );

  // Event 7
  const eventSeven = new Event(
    "Your citizens are happier and healthier because of your choices, this makes them more productive at work and live longer, healthier lives.",
    new Trigger(TriggerProperty.HealthHappinessAndWellbeing, 6, 1),
    new Result(0, 2, 2, 3, 0)
  );

  // Event 8
  const eventEight = new Event(
    "Your choices have helped wildlife in your city thrive and created a healthy ecosystem for local wildlife, your citizens like this.",
    new Trigger(TriggerProperty.Wildlife, 5, 1),
    new Result(2, 1, 0, 3, 3)
  );

  // Dev event
  const devEvent = new Event(
    "This is a dev event.",
    new Trigger(TriggerProperty.CarbonFootprint, -1, -1),
    new Result()
  );

  events.push(eventOne);
  events.push(eventTwo);
  events.push(eventThree);
  events.push(eventFour);
  events.push(eventFive);
  events.push(eventSix);
  events.push(eventSeven);
  events.push(eventEight);

  if (store.state.isDev) {
    // events.push(devEvent);
  }
}

function getActiveEvents(): Event[] {
  return events.filter((event: Event) => {
    let result = false;

    if (!event.activated) {
      if (event.trigger.direction === -1) {
        switch (event.trigger.property) {
          case TriggerProperty.CarbonFootprint:
            result = store.state.carbonFootprint < event.trigger.value;
            break;
          case TriggerProperty.EconomicProsperity:
            result = store.state.economicProsperity < event.trigger.value;
            break;
          case TriggerProperty.Employment:
            result = store.state.employment < event.trigger.value;
            break;
          case TriggerProperty.HealthHappinessAndWellbeing:
            result =
              store.state.healthHappinessAndWellbeing < event.trigger.value;
            break;
          case TriggerProperty.Wildlife:
            result = store.state.wildlife < event.trigger.value;
            break;
        }
      } else if (event.trigger.direction === 1) {
        switch (event.trigger.property) {
          case TriggerProperty.CarbonFootprint:
            result = store.state.carbonFootprint > event.trigger.value;
            break;
          case TriggerProperty.EconomicProsperity:
            result = store.state.economicProsperity > event.trigger.value;
            break;
          case TriggerProperty.Employment:
            result = store.state.employment > event.trigger.value;
            break;
          case TriggerProperty.HealthHappinessAndWellbeing:
            result =
              store.state.healthHappinessAndWellbeing > event.trigger.value;
            break;
          case TriggerProperty.Wildlife:
            result = store.state.wildlife > event.trigger.value;
            break;
        }
      }
    }

    return result;
  });
}

export { Event, events, awake, getActiveEvents };
